export const formatSeatVisibility = (visibility?: string | null): string => {
  const normalizedVisibility = visibility?.trim();

  if (!normalizedVisibility) return '';

  if (/^\d+(?:[.,]\d+)?\s*%?$/.test(normalizedVisibility)) {
    const percentage = normalizedVisibility.endsWith('%')
      ? normalizedVisibility
      : `${normalizedVisibility}%`;

    return `(возможное ограничение видимости до ${percentage})`;
  }

  return `(${normalizedVisibility})`;
};

export const formatSectorWithVisibility = (
  sectorName: string,
  visibility?: string | null
): string => {
  const visibilityLabel = formatSeatVisibility(visibility);

  return visibilityLabel ? `${sectorName} ${visibilityLabel}` : sectorName;
};
